import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController, ToastController, Platform } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { Settings } from '../../settings';

import { Calendar } from '@ionic-native/calendar';

import * as moment from "moment";


/**
 * Generated class for the VacationDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-vacation-details',
  templateUrl: 'vacation-details.html',
})
export class VacationDetailsPage {

  vacation: any;
  allowCancel: boolean = Settings.allowCancel;

  constructor(private platform: Platform, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, private alertCtrl: AlertController, public userProvider: UserProvider, public teamappProvider: TeamappProvider, private toastCtrl: ToastController, private calendar: Calendar) {
    this.vacation = this.navParams.get('vacation');
      console.log("... check compare");
    console.log(this.isDateInPastFormat(this.vacation.dateFrom));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VacationDetailsPage');
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }

  formatDate(date: any) {
    return moment(date).format("DD.MM.YYYY");
  }


  requestCalendarPermission(start: any, end: any) {

      let startM: string = moment(start).format("YYYY-MM-DD");
      let endM: string = moment(end).format("YYYY-MM-DD");

      let startF:any  = new Date(startM);
      let endF: any = new Date(endM);

      if(this.platform.is("ios")) {
          this.calendar.hasWritePermission().then((result)=>{
              console.log("hasReadWritePermission=>"+ result);
              if(!result){
                  this.calendar.requestWritePermission().then((s)=>{
                      this.addVacationToCalendar(startF, endF);
                  },(r)=>{
                      this.showPermissionError();
                  })
              }
              else
              {
                  this.addVacationToCalendar(startF, endF);
              }
          });
      } else {
          this.addVacationToCalendar(startF, endF);
      }


  }

  showPermissionError() {
      let alert = this.alertCtrl.create({
          title: 'Fehler',
          message: 'Der Urlaubsantrg konnte nicht in den Kalender eingetragen werden. Bitte überprüfe die Berechtigungen in den Einstellungen des Smartphones',
          buttons: [
              {
                  text: 'Ok',
                  role: 'cancel',
                  handler: () => {

                  }
              }
          ]
      });
      return alert.present();
  }
  addVacationToCalendar(from: any, till: any) {
      this.calendar.createEvent('Genemigter Urlaub', null, null, from, till).then(
          (msg) => {
              let alert = this.alertCtrl.create({
                  title: 'Urlaubsantrag',
                  message: 'Der Urlaubsantrag wurde in den Kalender übertragen',
                  buttons: [
                      {
                          text: 'Ok',
                          role: 'cancel',
                          handler: () => {

                          }
                      }
                  ]
              });
              alert.present();
          },
          (err) => { this.showPermissionError(); }
      );


  }

  cancelVacation(id: number) {
    let alert = this.alertCtrl.create({
        title: 'Urlaubsantrag',
        message: 'Grund der Stornierung?',
        inputs: [
            {
                name: 'reason',
                placeholder: 'Grund'
            },
        ],
        buttons: [
            {
                text: 'Abbrechen',
                role: 'cancel',
                handler: () => {

                }
            },
            {
                text: 'Stornierung anfordern',
                handler: (data) => {
                    if(data.reason.length > 0) {
                        this.teamappProvider.http_request('action=cancel_vacation&revoke_id='+id+"&revoke_reason="+data.reason, 'vacation', false).then(data => {
                            let toast = this.toastCtrl.create({
                                message: 'Stornierung angefragt. Wir senden eine Nachricht, sobald die Stornierung bearbeitet wurde.',
                                duration: 3000,
                                position: 'bottom'
                            });
                            toast.present();
                            this.closeModal();
                        });
                    } else {
                        let toast = this.toastCtrl.create({
                            message: 'Es muss ein Grund angegeben werden!',
                            duration: 3000,
                            position: 'bottom'
                        });
                        toast.present();
                        this.cancelVacation(id);
                    }

                }
            }
        ]
    });
    alert.present();
  }

  deleteVacation(id: number) {
    let alert = this.alertCtrl.create({
        title: 'Urlaubsantrag',
        message: 'Diesen Urlaubsantrag löschen?',
        buttons: [
            {
                text: 'Nein',
                role: 'cancel',
                handler: () => {

                }
            },
            {
                text: 'Ja',
                handler: () => {
                    this.teamappProvider.http_request('action=revoke_vacation&revoke_id='+id, 'vacation', false).then(data => {
                      let toast = this.toastCtrl.create({
                          message: 'Urlaubsantrag erfolgreich gelöscht!',
                          duration: 3000,
                          position: 'bottom'
                      });
                      toast.present();
                      this.closeModal();
                    });
                }
            }
        ]
    });
    alert.present();
  }


  isDateInPastFormat(date_time: any) {
      let d  = new Date(date_time);
      console.log(d);
      let d2 = new Date();
      console.log(d2);
      if(d2 > d) {
          return false;
      } else {
          return true;
      }
  }

}



// WEBPACK FOOTER //
// ./src/pages/vacation-details/vacation-details.ts